import {
    VinWarrantyRegistrationDTO,
    VinDTO,
    WarrantyRegistrationClient_V1,
    WarrantyRegistrationDTO,
    VinOwnerHistoryDTO,
    WarrantyRegistrationSearchDTO,
    AttachmentInfoDTO,
} from './generated/api.generated.v1';
import ApiConfig from './ApiConfig';
import { ApiHelper } from 'src/utils';

export default class WarrantyRegistrationService {
    private readonly _warrantyClient: WarrantyRegistrationClient_V1;

    constructor() {
        this._warrantyClient = new WarrantyRegistrationClient_V1(new ApiConfig(), process.env.VUE_APP_API_V1_URL);
    }

    public WarrantyRegistrations(dealerAccountUid: string, dto: WarrantyRegistrationSearchDTO): Promise<Array<WarrantyRegistrationDTO>> {
        return this._warrantyClient.warrantyRegistrations(dto, dealerAccountUid);
    }

    public RegisterVinWarranty(dealerAccountUid: string, dto: VinWarrantyRegistrationDTO){
        return ApiHelper.ParseDTO<VinWarrantyRegistrationDTO>(() => this._warrantyClient.registerVinWarranty(dto, dealerAccountUid));
    }    
    public VinOwnerHistories(dealerAccountUid: string, vin: string | null = null): Promise<Array<VinOwnerHistoryDTO>> {
        return this._warrantyClient.vinOwnerHistories(dealerAccountUid, vin);
    }

    public VinDetails(dealerAccountUid: string, vin: string): Promise<VinDTO>{
        return this._warrantyClient.dynamicsVinInfo(dealerAccountUid, vin);
    }

    public WarrantyRegistrationReport(dealerAccountUid: string, vin: string): Promise<AttachmentInfoDTO>{
        return this._warrantyClient.warrantyRegistrationReport(dealerAccountUid, vin);
    }
}